/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpLeftIcon32Regular = forwardRef('ArrowDUturnUpLeftIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M12.316.77a1 1 0 0 1 1.368 1.46L7.529 8H17.5C23.3 8 28 12.701 28 18.5S23.3 29 17.5 29H10a1 1 0 1 1 0-2h7.5a8.5 8.5 0 0 0 0-17H7.53l6.155 5.77a1 1 0 1 1-1.368 1.46l-6.444-6.041a3 3 0 0 1 0-4.378l6.444-6.04Z" })));
});
